package com.trevorwiebe.timesheet.mileage.data

import com.trevorwiebe.timesheet.core.domain.TSResult
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.storage.Data
import dev.gitlive.firebase.storage.storage
import io.ktor.client.HttpClient
import io.ktor.client.request.get
import io.ktor.client.statement.bodyAsBytes
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

expect fun ByteArray.toFirebaseData(): Data

// On Android the Firebase Storage emulator advertises itself as 127.0.0.1, but from
// inside the Android emulator the host machine is only reachable at 10.0.2.2.
expect fun fixStorageEmulatorUrl(url: String): String

class ReceiptStorageRepository(private val httpClient: HttpClient) {
    @OptIn(ExperimentalUuidApi::class)
    suspend fun uploadReceipt(
        imageBytes: ByteArray,
        orgId: String,
        userId: String,
        filename: String? = null
    ): TSResult {
        return try {
            val actualFilename = filename ?: "${Uuid.random()}.jpg"
            val ref = Firebase.storage.reference
                .child("organizations/$orgId/receipts/$userId/$actualFilename")
            ref.putData(imageBytes.toFirebaseData())
            TSResult(data = ref.getDownloadUrl())
        } catch (e: Exception) {
            TSResult(error = e.message ?: "Failed to upload receipt")
        }
    }

    suspend fun downloadBytes(url: String): ByteArray? {
        return try {
            withContext(Dispatchers.Default) {
                httpClient.get(fixStorageEmulatorUrl(url)).bodyAsBytes()
            }
        } catch (e: CancellationException) {
            throw e
        } catch (e: Throwable) {
            // Ktor's JS engine reports a failed fetch (e.g. blocked by CORS) as kotlin.Error, not Exception.
            null
        }
    }
}
